'use client';

import React, { CSSProperties } from 'react';

import { copyToClipboard } from '@cineamo/ui/src/helpers/clipboard-helper';

type AdBannerButtonProps = {
    config: {
        buttonText: string;
        buttonStyle: CSSProperties;
        buttonHref: string;
    };
    onClick: () => void;
};

const AdBannerButton: React.FC<AdBannerButtonProps> = ({ config, onClick }) => {
    async function onButtonClick() {
        onClick();
        copyToClipboard(config.buttonText);
    }
    return (
        <a
            className="absolute left-0 top-0 w-full h-full"
            href={config.buttonHref}
            onClick={onButtonClick}
        />
    );
};

export default AdBannerButton;
